<template>
  <v-app>
      <div id="google_translate_element_global" style="display:none;"></div>
    
    <!-- Show loading indicator while initializing -->
    <div v-if="!translatorReady" class="translator-loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <span>Loading translator...</span>
    </div>
     <Master />
  </v-app>
</template>

<script>
import Master from '../src/components/Master.vue'
export default {
  name: 'App',
   components: {
    Master
  },
   data() {
    return {
      translatorReady: false
    };
  },
  async mounted() {
    // Initialize Google Translate once for entire app
    try {
      await this.$translator.init();
      this.translatorReady = true;
      
      // Restore saved language after init
      await this.$translator.restoreSavedLanguage();
    } catch (error) {
      console.error("Failed to initialize translator:", error);
      this.translatorReady = true; // Show app anyway
    }
  }
};
</script>
